import { component as defineComponent } from 'flightjs';
import withCounter from 'app/mixins/with-counter';

var contestWatchersAction = function () {
    this.attributes({
        watchButton: '[data-contest-watchers-watch-button]',
        unwatchButton: '[data-contest-watchers-unwatch-button]',
        watcherCount: '[data-contest-watchers-count]',
    });

    this.after('initialize', function () {
        this.on('click', {
            watchButton: this.watchContest,
            unwatchButton: this.unwatchContest,
        });
    });

    this.watchContest = function (e) {
        this.trigger('uiContestActionRequested', {
            url: this.select('watchButton').data('url'),
        });
        this.$node.attr('data-watched', true);
        this.incrementCount('watcherCount');
    };

    this.unwatchContest = function (e) {
        this.trigger('uiContestActionRequested', {
            url: this.select('unwatchButton').data('url'),
        });

        // escape hatch, allows those subscribed to a locked contest
        // to unsubscribe and removes unactionable "Watch" ui
        if (this.$node.attr('data-can-watch') === 'false') {
            this.teardown();
            this.$node.parent('.meta-item-list__item').remove();
            return;
        }

        this.$node.attr('data-watched', false);
        this.decrementCount('watcherCount');
    };
};

export default defineComponent(contestWatchersAction, withCounter);



// WEBPACK FOOTER //
// ./src/web/js/contest/ui/contest-watchers-action.js